import {
  PROFILE_DETAILS_FAILED,
  PROFILE_DETAILS_INVALID_REQUEST,
  PROFILE_DETAILS_SUCCESS,
  LOADING_PROFILE_DETAILS,
  RESET_PROFILE_DETAILS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PROFILE_DETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        invalidRequest: false,
        failed: false,
      };

    case PROFILE_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
      };
    case PROFILE_DETAILS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        failed: false,
        success: false,
      };
    case PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        failed: false,
        success: true,
        data: action.payload,
      };

    case RESET_PROFILE_DETAILS:
      return (state = initialState);

    default:
      return state;
  }
};
